import { Component, EventEmitter, Input, OnChanges, SimpleChanges, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { FormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.css'],
  standalone: true,
  imports: [TranslateModule, MatPaginatorModule, FormsModule]
})
export class PaginationComponent implements OnChanges {

  @Input() tooltipLabel: string;
  @Input() iconStyle: string;
  @Input() itemsSearchStyle: string;
  @Input() itemsSearch: string = '';
  @Input() itemsPerPage: number = 10;
  @Input() totalItems: number = 0;
  @Input() totalItemsStyle: string;
  @Input() currentPage: number = 1;

  @Output() searchedData: EventEmitter<string> = new EventEmitter();
  @Output() itemPerPageData: EventEmitter<number> = new EventEmitter();
  @Output() nextPageChange: EventEmitter<number> = new EventEmitter();

  paginator: any;

  itemsPerPageOptions = [
    { name: '1', value: 1 },
    { name: '5', value: 5 },
    { name: '10', value: 10 },
    { name: '20', value: 20 },
    { name: '50', value: 50 },
    { name: '100', value: 100 },
    { name: '200', value: 200 },
    { name: '500', value: 500 },
    { name: '1000', value: 1000 },
    { name: 'All', value: 0 }
  ];

  ngOnChanges(changes: SimpleChanges) {
    // Make sure paginator reflects any parent changes
    if (changes['currentPage'] && !changes['currentPage'].firstChange) {
      this.currentPage = changes['currentPage'].currentValue;
      if (this.paginator) {
        this.paginator.pageIndex = this.currentPage - 1;
      }
      if (changes['itemsPerPage'] && !changes['itemsPerPage'].firstChange) {
        this.itemsPerPage = changes['itemsPerPage'].currentValue;
        if (this.paginator) {
          this.paginator.pageIndex = 0;
        }
      }
    }
  }

  handlePageChange(event: any) {
    // MatPaginator is 0-based
    this.currentPage = event.pageIndex + 1;

    // Update itemsPerPage if changed
    if (this.itemsPerPage !== event.pageSize) {
      this.itemsPerPage = event.pageSize;
      this.itemPerPageData.emit(this.itemsPerPage);
    }

    this.nextPageChange.emit(this.currentPage);
  }

  onPerPageItemChange() {
    this.currentPage = 1; // Reset page when selecting new page size
    this.itemPerPageData.emit(this.itemsPerPage);
    this.nextPageChange.emit(this.currentPage);
  }

  search() {
    this.currentPage = 1; // Reset page when searching
    this.searchedData.emit(this.itemsSearch);
    this.nextPageChange.emit(this.currentPage);
  }
}
